import { isEmpty } from "lodash";
import { FormItemLayoutProperties, LayoutService } from "./layout-service";
import { Box } from "@mui/material";
import "./default-form-layout.scss";

export const DefaultFormLayout = {
  name: "DefaultFormLayout",
  layoutFormItem: (
    formItemLayoutProperties: FormItemLayoutProperties,
    _showErrors?: boolean
  ) => {
    return formItemLayoutProperties.input;
  },
  layoutForm: (formItems: Record<string, JSX.Element>): JSX.Element => {
    if (isEmpty(formItems)) return <></>;
    return (
      <Box
        className={`_default-form-layout.tsx ${DefaultFormLayout.name}`}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        {Object.keys(formItems).map((key) => {
          return formItems[key];
        })}
      </Box>
    );
  },
};

LayoutService.get().register(DefaultFormLayout);
